// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Monitoring Page Styles
 * Styles specific to the monitoring heatmap view
 */

/* Statistics Cards */
.monitoring-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-xl);
}

.monitoring-stats__card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-lg);
  background-color: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

.monitoring-stats__content {
  flex: 1 1;
}

.monitoring-stats__label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  font-weight: 500;
  margin-bottom: var(--spacing-xs);
}

.monitoring-stats__value {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--color-text-primary);
}

.monitoring-stats__icon {
  padding: var(--spacing-sm);
  border-radius: var(--radius-lg);
}

/* Heatmap Container */
.heatmap {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 180px);
  min-height: 400px;
  background-color: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.heatmap__header {
  position: sticky;
  top: 0;
  background-color: var(--color-bg-primary);
  /*z-index: var(--z-index-sticky);*/
  padding: var(--spacing-xs) var(--spacing-sm);
  border-bottom: 1px solid var(--color-gray-200);
  flex-shrink: 0;
}

.heatmap__timeline {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

/* Search Section in Header */
.heatmap__search-section {
  width: 10rem;
  min-width: 8rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.heatmap__search-container {
  display: flex;
  align-items: center;
  background-color: var(--color-bg-secondary);
  border: 1px solid var(--color-gray-300);
  border-radius: var(--radius-md);
  padding: 0 var(--spacing-sm);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.heatmap__search-container:focus-within {
  border-color: var(--color-primary-500);
  box-shadow: 0 0 0 2px var(--color-primary-100);
}

.heatmap__search-icon {
  width: 0.85rem;
  height: 0.85rem;
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}

.heatmap__search-input {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 2px var(--spacing-xs);
  font-size: 0.7rem;
  color: var(--color-text-primary);
  outline: none;
  min-width: 0;
}

.heatmap__search-input::placeholder {
  color: var(--color-text-tertiary);
}

.heatmap__search-clear {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: var(--color-text-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  transition: color var(--transition-fast), background-color var(--transition-fast);
}

.heatmap__search-clear:hover {
  color: var(--color-text-primary);
  background-color: var(--color-gray-200);
}

.heatmap__search-count {
  font-size: 0.6rem;
  color: var(--color-text-tertiary);
  text-align: center;
}

.heatmap__vehicle-placeholder {
  width: 12rem;
  flex-shrink: 0;
}

/* Scrollable Vehicles Container */
.heatmap__vehicles-scroll {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: var(--spacing-xs);
}

.heatmap__hours {
  display: flex;
  flex: 1 1;
  gap: 1px;
}

.heatmap__hour {
  flex: 1 1;
  min-width: 0;
  text-align: center;
}

.heatmap__hour-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.heatmap__hour-sublabel {
  font-size: 0.65rem;
  color: var(--color-text-tertiary);
  margin-top: 1px;
}

/* Vehicle Rows */
.heatmap__vehicles {
  margin-top: var(--spacing-xs);
}

.heatmap__vehicle {
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-md);
  overflow: hidden;
  margin-bottom: 4px;
}

.heatmap__vehicle-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: 4px var(--spacing-sm);
  background-color: var(--color-bg-secondary);
  cursor: pointer;
  transition: background-color var(--transition-base);
  width: 100%;
  border: none;
  text-align: left;
}

.heatmap__vehicle-header:hover {
  background-color: var(--color-bg-tertiary);
}

.heatmap__vehicle-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-text-secondary);
  transition: transform var(--transition-base);
}

.heatmap__vehicle-icon--expanded {
  transform: rotate(90deg);
}

.heatmap__vehicle-plate {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
}

.heatmap__vehicle-count {
  font-size: var(--font-size-sm);
  color: var(--color-text-tertiary);
}

/* Grounded vehicle: whole block reads as inactive/disabled */
.heatmap__vehicle--grounded {
  opacity: 0.55;
  filter: grayscale(70%);
}

.heatmap__vehicle-header--grounded {
  background-color: var(--color-gray-100);
}

.dark .heatmap__vehicle-header--grounded {
  background-color: var(--color-gray-800);
}

/* Status badge (Grounded / Category Muted) */
.heatmap__status-badge {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  background-color: var(--color-gray-200);
  color: var(--color-text-secondary);
  white-space: nowrap;
  flex-shrink: 0;
}

.dark .heatmap__status-badge {
  background-color: var(--color-gray-700);
  color: var(--color-text-secondary);
}

.heatmap__status-badge--grounded {
  background-color: var(--color-gray-300);
  color: var(--color-text-primary);
}

.dark .heatmap__status-badge--grounded {
  background-color: var(--color-gray-600);
}

.heatmap__status-badge--muted {
  background-color: var(--color-gray-200);
  color: var(--color-text-tertiary);
}

/* Sensor Rows */
.heatmap__sensors {
  divide-y: 1px solid var(--color-gray-200);
}

.heatmap__sensor {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: 2px var(--spacing-xs);
  background-color: var(--color-bg-primary);
}

/* Muted door (category/vehicle/door mute schedule active): dim the row,
   including its 24-hour blocks, without hiding the underlying data. */
.heatmap__sensor--muted {
  opacity: 0.5;
  filter: grayscale(85%);
}

.heatmap__sensor-info {
  width: 10rem;
  min-width: 8rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-xs);
  flex-wrap: wrap;
  gap: 1px;
}

.heatmap__sensor-name {
  font-size: 0.7rem;
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.heatmap__sensor-normal {
  font-size: 0.7rem;
  color: green;
}

.heatmap__sensor-critical {
  font-size: 0.7rem;
  color: red;
}

.heatmap__sensor-warning {
  font-size: 0.7rem;
  color: orange;
}

.heatmap__sensor-temp {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.heatmap__sensor-temp--empty {
  color: var(--color-text-tertiary);
}

.heatmap__blocks {
  display: flex;
  flex: 1 1;
  gap: 1px;
}

/* Temperature Blocks */
.temp-block {
  flex: 1 1;
  min-width: 0;
  height: 1.5rem;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 500;
  cursor: default;
  transition: all var(--transition-fast);
  position: relative;
}

.temp-block:hover {
  transform: scale(1.1);
  z-index: 10;
  box-shadow: var(--shadow-lg);
}

.temp-block--clickable {
  cursor: pointer;
}

.temp-block--clickable:focus-visible {
  outline: 2px solid var(--color-primary-500, #3b82f6);
  outline-offset: 2px;
  z-index: 10;
}

.temp-block--normal {
  background-color: var(--color-success-500);
  color: white;
}

.temp-block--warning {
  background-color: var(--color-warning-500);
  color: white;
}

.temp-block--critical {
  background-color: var(--color-danger-500);
  color: white;
}

.temp-block--empty {
  background-color: var(--color-gray-200);
  color: var(--color-text-tertiary);
}

/* Wrapper for the value + variation shown inside a block in the "Numbers" view */
.temp-block__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
  overflow: hidden;
  max-width: 100%;
}

/* Numeric value shown inside a block when the "Numbers" view is active */
.temp-block__value {
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 2px;
  color: inherit;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
  max-width: 100%;
}

.temp-block--empty .temp-block__value {
  text-shadow: none;
}

/* Compact variation vs. the previous hourly reading, shown under the value.
   Color convention matches TemperatureDetailModal: warmer (up) leans red,
   cooler (down) leans blue; stable stays neutral. */
.temp-block__delta {
  font-size: 0.5rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
}

.temp-block__delta--up {
  color: var(--color-danger-200, #fecaca);
}

.temp-block__delta--down {
  color: var(--color-primary-200, #bfdbfe);
}

.temp-block__delta--stable {
  color: inherit;
  opacity: 0.85;
}

/* View mode toggle (Colors / Numbers) */
.heatmap__view-toggle {
  display: flex;
  gap: 2px;
  background-color: var(--color-bg-secondary);
  border: 1px solid var(--color-gray-300);
  border-radius: var(--radius-md);
  padding: 2px;
}

.heatmap__view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: var(--color-text-tertiary);
  font-size: 0.65rem;
  font-weight: 500;
  padding: 3px 6px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

.heatmap__view-toggle-btn:hover {
  color: var(--color-text-primary);
}

.heatmap__view-toggle-btn--active {
  background-color: var(--color-primary-500, #3b82f6);
  color: white;
}

.heatmap__view-toggle-icon {
  width: 0.8rem;
  height: 0.8rem;
  flex-shrink: 0;
}

/* Empty State */
.heatmap__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  height: 100%;
  min-height: 200px;
}

.heatmap__empty-icon {
  width: 4rem;
  height: 4rem;
  margin-bottom: 1rem;
  color: var(--color-gray-400);
}

.dark .heatmap__empty-icon {
  color: var(--color-gray-600);
}

.heatmap__empty-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.heatmap__empty-description {
  color: var(--color-text-secondary);
  margin-bottom: 1rem;
}

/* Legend */
.heatmap__legend {
  margin-top: var(--spacing-md);
  padding: var(--spacing-sm) var(--spacing-lg);
  background-color: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

.heatmap__legend-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-sm);
}

.heatmap__legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-md);
}

.heatmap__legend-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.heatmap__legend-color {
  width: 1rem;
  height: 1rem;
  border-radius: var(--radius-sm);
}

.heatmap__legend-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* Sparkline Styles */
.sparkline-empty {
  width: var(--sparkline-width, 150px);
  height: var(--sparkline-height, 40px);
}

/* Responsive Design */

/* Tablet and smaller - reduce search/sensor width */
@media (max-width: 1024px) {
  .heatmap__search-section {
    width: 8rem;
    min-width: 6rem;
  }

  .heatmap__sensor-info {
    width: 8rem;
    min-width: 6rem;
  }

  .heatmap__hour-label {
    font-size: 0.65rem;
  }

  .heatmap__hour-sublabel {
    display: none;
  }

  .temp-block {
    height: 1.3rem;
    font-size: 0.55rem;
  }

  .heatmap__sensor-name,
  .heatmap__sensor-normal,
  .heatmap__sensor-critical,
  .heatmap__sensor-warning,
  .heatmap__sensor-temp {
    font-size: 0.6rem;
  }
}

/* Small screens */
@media (max-width: 768px) {
  .heatmap {
    height: calc(100vh - 140px);
    min-height: 300px;
  }

  .heatmap__header {
    padding: var(--spacing-xs);
  }

  .heatmap__search-section {
    width: 6rem;
    min-width: 5rem;
  }

  .heatmap__sensor-info {
    width: 6rem;
    min-width: 5rem;
  }

  .heatmap__vehicle-plate {
    font-size: var(--font-size-xs);
  }

  .heatmap__search-input {
    font-size: 0.65rem;
    padding: 2px 4px;
  }

  .heatmap__search-icon {
    width: 0.75rem;
    height: 0.75rem;
  }

  .heatmap__search-count {
    font-size: 0.55rem;
  }
}

/* Very small screens */
@media (max-width: 480px) {
  .heatmap__search-section {
    width: 5rem;
    min-width: 4rem;
  }

  .heatmap__sensor-info {
    width: 5rem;
    min-width: 4rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }

  .heatmap__hour-label {
    font-size: 0.55rem;
  }

  .temp-block {
    height: 1.1rem;
    font-size: 0.45rem;
  }

  /* Not enough vertical room for a second line on very small screens */
  .temp-block__delta {
    display: none;
  }

  .heatmap__sensor-name,
  .heatmap__sensor-normal,
  .heatmap__sensor-critical,
  .heatmap__sensor-warning,
  .heatmap__sensor-temp {
    font-size: 0.5rem;
  }
}

/* Legend responsive */
@media (max-width: 768px) {
  .heatmap__legend {
    padding: var(--spacing-xs) var(--spacing-sm);
  }

  .heatmap__legend-items {
    gap: var(--spacing-sm);
  }

  .heatmap__legend-color {
    width: 0.75rem;
    height: 0.75rem;
  }

  .heatmap__legend-label {
    font-size: var(--font-size-xs);
  }
}

/* Stats cards responsive */
@media (max-width: 640px) {
  .monitoring-stats {
    grid-template-columns: 1fr;
    gap: var(--spacing-sm);
  }

  .monitoring-stats__card {
    padding: var(--spacing-md);
  }

  .monitoring-stats__value {
    font-size: var(--font-size-xl);
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/monitoring.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yCAAyC;EACzC,kCAAkC;EAClC,4CAA4C;EAC5C,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,kFAAkF;AACpF;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,iFAAiF;AACnF;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,2CAA2C;EAC3C,eAAe;EACf,mDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;EACvC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;sEACsE;AACtE;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,QAAQ;EACR,2CAA2C;EAC3C,uCAAuC;EACvC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA,sBAAsB;;AAEtB,oDAAoD;AACpD;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;;;;;IAKE,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,MAAM;EACR;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA,qEAAqE;EACrE;IACE,aAAa;EACf;;EAEA;;;;;IAKE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/**\n * Monitoring Page Styles\n * Styles specific to the monitoring heatmap view\n */\n\n/* Statistics Cards */\n.monitoring-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--spacing-md);\n  margin-bottom: var(--spacing-xl);\n}\n\n.monitoring-stats__card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-lg);\n  background-color: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.monitoring-stats__content {\n  flex: 1;\n}\n\n.monitoring-stats__label {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  margin-bottom: var(--spacing-xs);\n}\n\n.monitoring-stats__value {\n  font-size: var(--font-size-2xl);\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.monitoring-stats__icon {\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-lg);\n}\n\n/* Heatmap Container */\n.heatmap {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 180px);\n  min-height: 400px;\n  background-color: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n}\n\n.heatmap__header {\n  position: sticky;\n  top: 0;\n  background-color: var(--color-bg-primary);\n  /*z-index: var(--z-index-sticky);*/\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-bottom: 1px solid var(--color-gray-200);\n  flex-shrink: 0;\n}\n\n.heatmap__timeline {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n}\n\n/* Search Section in Header */\n.heatmap__search-section {\n  width: 10rem;\n  min-width: 8rem;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.heatmap__search-container {\n  display: flex;\n  align-items: center;\n  background-color: var(--color-bg-secondary);\n  border: 1px solid var(--color-gray-300);\n  border-radius: var(--radius-md);\n  padding: 0 var(--spacing-sm);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.heatmap__search-container:focus-within {\n  border-color: var(--color-primary-500);\n  box-shadow: 0 0 0 2px var(--color-primary-100);\n}\n\n.heatmap__search-icon {\n  width: 0.85rem;\n  height: 0.85rem;\n  color: var(--color-text-tertiary);\n  flex-shrink: 0;\n}\n\n.heatmap__search-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 2px var(--spacing-xs);\n  font-size: 0.7rem;\n  color: var(--color-text-primary);\n  outline: none;\n  min-width: 0;\n}\n\n.heatmap__search-input::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.heatmap__search-clear {\n  background: none;\n  border: none;\n  padding: 2px;\n  cursor: pointer;\n  color: var(--color-text-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n  transition: color var(--transition-fast), background-color var(--transition-fast);\n}\n\n.heatmap__search-clear:hover {\n  color: var(--color-text-primary);\n  background-color: var(--color-gray-200);\n}\n\n.heatmap__search-count {\n  font-size: 0.6rem;\n  color: var(--color-text-tertiary);\n  text-align: center;\n}\n\n.heatmap__vehicle-placeholder {\n  width: 12rem;\n  flex-shrink: 0;\n}\n\n/* Scrollable Vehicles Container */\n.heatmap__vehicles-scroll {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: var(--spacing-xs);\n}\n\n.heatmap__hours {\n  display: flex;\n  flex: 1;\n  gap: 1px;\n}\n\n.heatmap__hour {\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n}\n\n.heatmap__hour-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.heatmap__hour-sublabel {\n  font-size: 0.65rem;\n  color: var(--color-text-tertiary);\n  margin-top: 1px;\n}\n\n/* Vehicle Rows */\n.heatmap__vehicles {\n  margin-top: var(--spacing-xs);\n}\n\n.heatmap__vehicle {\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.heatmap__vehicle-header {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: 4px var(--spacing-sm);\n  background-color: var(--color-bg-secondary);\n  cursor: pointer;\n  transition: background-color var(--transition-base);\n  width: 100%;\n  border: none;\n  text-align: left;\n}\n\n.heatmap__vehicle-header:hover {\n  background-color: var(--color-bg-tertiary);\n}\n\n.heatmap__vehicle-icon {\n  width: 1rem;\n  height: 1rem;\n  color: var(--color-text-secondary);\n  transition: transform var(--transition-base);\n}\n\n.heatmap__vehicle-icon--expanded {\n  transform: rotate(90deg);\n}\n\n.heatmap__vehicle-plate {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.heatmap__vehicle-count {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-tertiary);\n}\n\n/* Grounded vehicle: whole block reads as inactive/disabled */\n.heatmap__vehicle--grounded {\n  opacity: 0.55;\n  filter: grayscale(70%);\n}\n\n.heatmap__vehicle-header--grounded {\n  background-color: var(--color-gray-100);\n}\n\n.dark .heatmap__vehicle-header--grounded {\n  background-color: var(--color-gray-800);\n}\n\n/* Status badge (Grounded / Category Muted) */\n.heatmap__status-badge {\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  background-color: var(--color-gray-200);\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.dark .heatmap__status-badge {\n  background-color: var(--color-gray-700);\n  color: var(--color-text-secondary);\n}\n\n.heatmap__status-badge--grounded {\n  background-color: var(--color-gray-300);\n  color: var(--color-text-primary);\n}\n\n.dark .heatmap__status-badge--grounded {\n  background-color: var(--color-gray-600);\n}\n\n.heatmap__status-badge--muted {\n  background-color: var(--color-gray-200);\n  color: var(--color-text-tertiary);\n}\n\n/* Sensor Rows */\n.heatmap__sensors {\n  divide-y: 1px solid var(--color-gray-200);\n}\n\n.heatmap__sensor {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: 2px var(--spacing-xs);\n  background-color: var(--color-bg-primary);\n}\n\n/* Muted door (category/vehicle/door mute schedule active): dim the row,\n   including its 24-hour blocks, without hiding the underlying data. */\n.heatmap__sensor--muted {\n  opacity: 0.5;\n  filter: grayscale(85%);\n}\n\n.heatmap__sensor-info {\n  width: 10rem;\n  min-width: 8rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--spacing-xs);\n  flex-wrap: wrap;\n  gap: 1px;\n}\n\n.heatmap__sensor-name {\n  font-size: 0.7rem;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.heatmap__sensor-normal {\n  font-size: 0.7rem;\n  color: green;\n}\n\n.heatmap__sensor-critical {\n  font-size: 0.7rem;\n  color: red;\n}\n\n.heatmap__sensor-warning {\n  font-size: 0.7rem;\n  color: orange;\n}\n\n.heatmap__sensor-temp {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.heatmap__sensor-temp--empty {\n  color: var(--color-text-tertiary);\n}\n\n.heatmap__blocks {\n  display: flex;\n  flex: 1;\n  gap: 1px;\n}\n\n/* Temperature Blocks */\n.temp-block {\n  flex: 1;\n  min-width: 0;\n  height: 1.5rem;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: 500;\n  cursor: default;\n  transition: all var(--transition-fast);\n  position: relative;\n}\n\n.temp-block:hover {\n  transform: scale(1.1);\n  z-index: 10;\n  box-shadow: var(--shadow-lg);\n}\n\n.temp-block--clickable {\n  cursor: pointer;\n}\n\n.temp-block--clickable:focus-visible {\n  outline: 2px solid var(--color-primary-500, #3b82f6);\n  outline-offset: 2px;\n  z-index: 10;\n}\n\n.temp-block--normal {\n  background-color: var(--color-success-500);\n  color: white;\n}\n\n.temp-block--warning {\n  background-color: var(--color-warning-500);\n  color: white;\n}\n\n.temp-block--critical {\n  background-color: var(--color-danger-500);\n  color: white;\n}\n\n.temp-block--empty {\n  background-color: var(--color-gray-200);\n  color: var(--color-text-tertiary);\n}\n\n/* Wrapper for the value + variation shown inside a block in the \"Numbers\" view */\n.temp-block__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n/* Numeric value shown inside a block when the \"Numbers\" view is active */\n.temp-block__value {\n  font-size: 0.6rem;\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 2px;\n  color: inherit;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.35);\n  max-width: 100%;\n}\n\n.temp-block--empty .temp-block__value {\n  text-shadow: none;\n}\n\n/* Compact variation vs. the previous hourly reading, shown under the value.\n   Color convention matches TemperatureDetailModal: warmer (up) leans red,\n   cooler (down) leans blue; stable stays neutral. */\n.temp-block__delta {\n  font-size: 0.5rem;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.35);\n}\n\n.temp-block__delta--up {\n  color: var(--color-danger-200, #fecaca);\n}\n\n.temp-block__delta--down {\n  color: var(--color-primary-200, #bfdbfe);\n}\n\n.temp-block__delta--stable {\n  color: inherit;\n  opacity: 0.85;\n}\n\n/* View mode toggle (Colors / Numbers) */\n.heatmap__view-toggle {\n  display: flex;\n  gap: 2px;\n  background-color: var(--color-bg-secondary);\n  border: 1px solid var(--color-gray-300);\n  border-radius: var(--radius-md);\n  padding: 2px;\n}\n\n.heatmap__view-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-tertiary);\n  font-size: 0.65rem;\n  font-weight: 500;\n  padding: 3px 6px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: background-color var(--transition-fast), color var(--transition-fast);\n}\n\n.heatmap__view-toggle-btn:hover {\n  color: var(--color-text-primary);\n}\n\n.heatmap__view-toggle-btn--active {\n  background-color: var(--color-primary-500, #3b82f6);\n  color: white;\n}\n\n.heatmap__view-toggle-icon {\n  width: 0.8rem;\n  height: 0.8rem;\n  flex-shrink: 0;\n}\n\n/* Empty State */\n.heatmap__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1rem;\n  text-align: center;\n  height: 100%;\n  min-height: 200px;\n}\n\n.heatmap__empty-icon {\n  width: 4rem;\n  height: 4rem;\n  margin-bottom: 1rem;\n  color: var(--color-gray-400);\n}\n\n.dark .heatmap__empty-icon {\n  color: var(--color-gray-600);\n}\n\n.heatmap__empty-title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.heatmap__empty-description {\n  color: var(--color-text-secondary);\n  margin-bottom: 1rem;\n}\n\n/* Legend */\n.heatmap__legend {\n  margin-top: var(--spacing-md);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background-color: var(--color-bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.heatmap__legend-title {\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.heatmap__legend-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-md);\n}\n\n.heatmap__legend-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.heatmap__legend-color {\n  width: 1rem;\n  height: 1rem;\n  border-radius: var(--radius-sm);\n}\n\n.heatmap__legend-label {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n/* Sparkline Styles */\n.sparkline-empty {\n  width: var(--sparkline-width, 150px);\n  height: var(--sparkline-height, 40px);\n}\n\n/* Responsive Design */\n\n/* Tablet and smaller - reduce search/sensor width */\n@media (max-width: 1024px) {\n  .heatmap__search-section {\n    width: 8rem;\n    min-width: 6rem;\n  }\n\n  .heatmap__sensor-info {\n    width: 8rem;\n    min-width: 6rem;\n  }\n\n  .heatmap__hour-label {\n    font-size: 0.65rem;\n  }\n\n  .heatmap__hour-sublabel {\n    display: none;\n  }\n\n  .temp-block {\n    height: 1.3rem;\n    font-size: 0.55rem;\n  }\n\n  .heatmap__sensor-name,\n  .heatmap__sensor-normal,\n  .heatmap__sensor-critical,\n  .heatmap__sensor-warning,\n  .heatmap__sensor-temp {\n    font-size: 0.6rem;\n  }\n}\n\n/* Small screens */\n@media (max-width: 768px) {\n  .heatmap {\n    height: calc(100vh - 140px);\n    min-height: 300px;\n  }\n\n  .heatmap__header {\n    padding: var(--spacing-xs);\n  }\n\n  .heatmap__search-section {\n    width: 6rem;\n    min-width: 5rem;\n  }\n\n  .heatmap__sensor-info {\n    width: 6rem;\n    min-width: 5rem;\n  }\n\n  .heatmap__vehicle-plate {\n    font-size: var(--font-size-xs);\n  }\n\n  .heatmap__search-input {\n    font-size: 0.65rem;\n    padding: 2px 4px;\n  }\n\n  .heatmap__search-icon {\n    width: 0.75rem;\n    height: 0.75rem;\n  }\n\n  .heatmap__search-count {\n    font-size: 0.55rem;\n  }\n}\n\n/* Very small screens */\n@media (max-width: 480px) {\n  .heatmap__search-section {\n    width: 5rem;\n    min-width: 4rem;\n  }\n\n  .heatmap__sensor-info {\n    width: 5rem;\n    min-width: 4rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0;\n  }\n\n  .heatmap__hour-label {\n    font-size: 0.55rem;\n  }\n\n  .temp-block {\n    height: 1.1rem;\n    font-size: 0.45rem;\n  }\n\n  /* Not enough vertical room for a second line on very small screens */\n  .temp-block__delta {\n    display: none;\n  }\n\n  .heatmap__sensor-name,\n  .heatmap__sensor-normal,\n  .heatmap__sensor-critical,\n  .heatmap__sensor-warning,\n  .heatmap__sensor-temp {\n    font-size: 0.5rem;\n  }\n}\n\n/* Legend responsive */\n@media (max-width: 768px) {\n  .heatmap__legend {\n    padding: var(--spacing-xs) var(--spacing-sm);\n  }\n\n  .heatmap__legend-items {\n    gap: var(--spacing-sm);\n  }\n\n  .heatmap__legend-color {\n    width: 0.75rem;\n    height: 0.75rem;\n  }\n\n  .heatmap__legend-label {\n    font-size: var(--font-size-xs);\n  }\n}\n\n/* Stats cards responsive */\n@media (max-width: 640px) {\n  .monitoring-stats {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-sm);\n  }\n\n  .monitoring-stats__card {\n    padding: var(--spacing-md);\n  }\n\n  .monitoring-stats__value {\n    font-size: var(--font-size-xl);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
